import { UseCustomAxios } from "../../UseCustomAxios";

export function UseConsultantOrdersReport() {
  const MyAxios = UseCustomAxios();

  const GetConsultantOrdersReport = (state, newMyPc, bool, callback) => {
    let url = "Admin_ConsulatorOrdersReport";

    if (
      state.date1 &&
      state.date1 !== undefined &&
      state.date2 &&
      state.date2 !== undefined
    ) {
      url += `/${state.date1}/${state.date2}`;
    }
    MyAxios.get(url, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: newMyPc }),
        IsPage: bool,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetConsultantOrderDetail = (id, state, callback) => {
    let url = `Admin_ConsulatorOrdersReport/detail/${id}`;

    if (
      state.date1 &&
      state.date1 !== undefined &&
      state.date2 &&
      state.date2 !== undefined
    ) {
      url += `/${state.date1}/${state.date2}`;
    }

    MyAxios.get(url).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  return {
    GetConsultantOrdersReport,
    GetConsultantOrderDetail,
  };
}
